
import React, { useState, useEffect } from 'react';
import { Assignment, FileCopySharp, Add } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';


//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Pregunta', accessor: 'pregunta'},
  { Header: 'Nombre del supervisor', accessor: 'NombreVendedor'},
  { Header: 'Descripción diccionario', accessor: 'descripcion'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const { id } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [supervisor, setSupervisores] = useState([]);
  const [respuestas, setRespuestas] = useState([]);


  async function getSupervisor(idrespuesta) {
    setDataLoading(true);
    let response = await wsGet('sale/form-supervisores', idrespuesta);
    setDataLoading(false);
    if (response.success) {
      setSupervisores(response.data);
    }
  }

  async function listRespuestas() {
    setDataLoading(true);
    let response = await wsFindBy('sale/form-supervisores-detail', { id_respuesta: id });
    setDataLoading(false);
    if (response.success) setRespuestas(response.data);
  }

  useEffect(() => {
    getSupervisor(id);
    listRespuestas();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado Detallado de Formularios para Supervisores
            <span style={{ fontSize: '14px' }}>
              <b>{` (${supervisor.NombreVendedor || ''})`}</b>
            </span>
            {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="listado_detallado_respuestas_supervisores"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={respuestas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    </div>
                  ),
                  pregunta: item.pregunta,
                  NombreVendedor: item.NombreVendedor,
                  descripcion: item.descripcion,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
